export default {
  APPEND_RESULTS: 'PG_APPEND_RESULTS',
  UPDATE_RESULT: 'PG_UPDATE_RESULT',
  SET_JOB_STATUS: 'PG_SET_JOB_STATUS',
  UPDATE_JOB_STATUS: 'PG_UPDATE_JOB_STATUS',
}
